import { inject, Injectable, signal } from '@angular/core';
import { DriftsMeddelelse } from './driftsmeddelelse.model';
import { DriftsMeddelelserDatasource } from './driftsmeddelelser.datasource';

@Injectable({
  providedIn: 'root',
})
export class DriftsMeddelelserService {
  datasource = inject(DriftsMeddelelserDatasource);
  selectedDriftsMeddelelse = signal<DriftsMeddelelse | undefined>(undefined);
  activeTab = signal('list');
  mode = signal('update');
  searchText = signal('');

  selectDriftsMeddelelse(driftsMeddelelse: DriftsMeddelelse) {
    this.mode.set('update');
    this.selectedDriftsMeddelelse.set(driftsMeddelelse);

    if (driftsMeddelelse) {
      this.activeTab.set('detail');
    }
  }

  opretDriftsMeddelelse() {
    this.mode.set('create');
    this.selectedDriftsMeddelelse.set(undefined);
    this.activeTab.set('detail');
  }

  onSearch() {
    this.datasource.searchParams.set({
      text: this.searchText(),
    });
  }
}
